import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  modal: {
    '& .MuiModal-backdrop': {
      background: 'transparent',
    },
  },
  checkboxWrapper: {
    ...dFlex('flex-end'),
    gap: 11,
    paddingTop: 16,
  },
  description: {
    paddingBottom: 32,
  },
}));

export default useStyles;
